var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 71,
    viewBox: "0 0 119 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1_96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.5557 0.00745618C35.0383 -0.004113 34.5133 -0.004113 33.9883 0.00745618C15.4699 0.427803 0.418847 15.7955 0.00716117 34.7034C-0.430964 54.907 15.7608 71.4394 35.5482 70.992C46.9545 70.7337 57.0427 64.8064 63.2104 55.8711C63.573 55.3428 63.9243 54.8029 64.2604 54.2553C67.4746 49.0183 69.3857 42.8712 69.5293 36.2961C69.9561 16.6285 54.6217 0.439372 35.5557 0.00745618ZM33.909 54.2322C24.4855 53.7887 16.8561 45.9988 16.4255 36.3809C15.927 25.3478 24.8292 16.2621 35.635 16.7673C45.0585 17.2108 52.6879 25.0007 53.1185 34.6224C53.617 45.6556 44.7148 54.7412 33.909 54.236V54.2322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M94.2309 0.00769043V45.7869C94.2309 59.5812 83.2437 71 69.7299 71H64.2193V54.2517H69.7299C74.198 54.2517 77.8276 50.5418 77.8276 45.9797V0.00769043H94.2309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M119 33.4966V71H102.601V16.756H102.604L119 33.4966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M108.772 16.7213H102.601V10.4122C104.304 10.4122 105.845 11.1218 106.959 12.2594C108.077 13.4009 108.768 14.9782 108.768 16.7213H108.772Z",
    fill: "#48D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M119 16.756H113.897C113.897 13.5668 112.632 10.6783 110.581 8.5843C108.538 6.49799 105.713 5.20225 102.597 5.20225V0.00769043C107.125 0.00769043 111.227 1.8819 114.192 4.91302C117.161 7.94414 118.996 12.1322 118.996 16.756H119Z",
    fill: "#48D6C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M108.772 16.7213H102.601V10.4122C104.304 10.4122 105.845 11.1218 106.959 12.2594C108.077 13.4009 108.768 14.9782 108.768 16.7213H108.772Z",
    fill: "#48D6C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 71,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOji);
export default __webpack_public_path__ + "static/media/OJI.8b9850a48596d2b6eeeeffc0389a90d4.svg";
export { ForwardRef as ReactComponent };